"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_titled-form-block.scss");

function TitledFormBlock(_ref) {
  var itemImage = _ref.itemImage,
      title = _ref.title,
      className = _ref.className,
      defaultImage = _ref.defaultImage,
      imagePlaceholder = _ref.imagePlaceholder,
      children = _ref.children,
      hasSelectedItem = _ref.hasSelectedItem,
      customContent = _ref.customContent;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("titled-form-block", className)
  }, title ? _react["default"].createElement("p", {
    className: "titled-form-block__title"
  }, title) : null, _react["default"].createElement("div", {
    className: (0, _classnames["default"])("titled-form-block__content", {
      "titled-form-block__content--selection-made": hasSelectedItem
    })
  }, customContent ? children : [_react["default"].createElement(_uiKit.Image, {
    key: "selectable-item-image",
    width: "90px",
    height: "90px",
    imageUrl: itemImage,
    defaultImageIcon: defaultImage,
    placeholderText: imagePlaceholder
  }), _react["default"].createElement("div", {
    className: "titled-form-block__content__children",
    key: "selectable-item-children"
  }, children)]));
}

var _default = (0, _react.memo)(TitledFormBlock);

exports["default"] = _default;